import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

const MetaPixelTracker = () => {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (!window.fbq) return;

    // Skip duplicate first PageView (index.html already fired it)
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    window.fbq("track", "PageView");
  }, [location.pathname]);

  return <Outlet />;
};

export default MetaPixelTracker;